import Api from './api.service'

import Configuration from '@/configuration';
const baseURL = Configuration.value('authUrl')

export default {
  me() {
    return Api().post(`${baseURL}/check-tenant`)
  }
}
